const getColumnsHeaders = (intl) => ({
  supplier: { sortable: true, searchable: true },
  name: { sortable: true, searchable: true },
  model: {
    sortable: true,
    filterable: true,
    filterableDropdownWidth: 150,
    filterableData: {
      1: {
        value: 'delivery',
        label: intl.formatMessage({
          id: 'pages.quality.ocr.templates.delivery',
        }),
      },
      2: {
        value: 'deliveryPC',
        label: intl.formatMessage({
          id: 'pages.quality.ocr.templates.deliveryPC',
        }),
      },
      3: {
        value: 'laboratory',
        label: intl.formatMessage({
          id: 'pages.quality.ocr.templates.laboratory',
        }),
      },
    },
  },
  updatedAt: { isDate: true, translatable: true, sortable: true },
});

const BUTTONS = {
  editAction: { tooltip: 'editAction.template' },
  deleteAction: { tooltip: 'deleteAction.template' },
  copyAction: { tooltip: 'copyAction.template' },
};

export { getColumnsHeaders, BUTTONS };
